import * as yup from 'yup';

export const schema = yup
  .object({
    code: yup.string().required('Code is required.').max(6, 'Max length is 6 characters.'),
  })
  .required();

export type FormData = yup.InferType<typeof schema>;
